<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>-->
<div class="page-content-wrapper">
    <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
      <ol class="breadcrumb bc-3">
        <li>
          <a [routerLink]="'/home'">Home</a>
        </li>
        <li>
          <a>Risk Management</a>
        </li>
      </ol>
  
      <div class="inner-wrapper">
         
        <div class="sub-wrapper" style="display: contents;">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" aria-current="page">
                Pending For Approval
              </li>
            </ol>
          </nav>
          <div class="section-wrapper">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div class="table-responsive margin-top-15">
              <table
                class="table table-bordered table-striped table-condensed fix-tablelayout"
              >
                <thead>
                  <tr>
                    
                    <th rowspan="2">
                      {{ "RISK.RISK_ID" | translate }}
                    </th>
                    <th  rowspan="2">
                      {{ "RISK.UNIT" | translate }}
                    </th>
                    <th  rowspan="2">
                        Risk Management Tool
                      </th>
                    <th  rowspan="2">Source</th>
                    <th  rowspan="2">Approval Status </th>
                    <th  rowspan="2">Last Approval Date </th>
                  </tr>
                  
                </thead>
                <tbody>
                  <tr
                    
                    #row
                    *ngFor="
                      let risk of riskData"
                    id="{{ risk.DisplayId }}"
                  >
                     
                    <td
                      (click)="getCurrentDOMElementId(risk.DisplayId)"
                      [routerLink]="[
                      '/risk/'+ risk.PageName,
                      risk.RiskRequestId,
                      { App: risk.ApprovalLevel }
                    ]"
                    >
                      {{risk.DisplayId}} 
                    </td>
                      <td
                      (click)="getCurrentDOMElementId(risk.DisplayId)"
                      [routerLink]="[
                      '/risk/'+ risk.PageName,
                      risk.RiskRequestId,
                      { App: risk.ApprovalLevel }
                    ]"
                    >
                      {{ risk.UnitName }}
                    </td>
                    <td
                      (click)="getCurrentDOMElementId(risk.DisplayId)"
                      [routerLink]="[
                      '/risk/'+ risk.PageName,
                      risk.RiskRequestId,
                      { App: risk.ApprovalLevel }
                    ]"
                    >
                      {{ risk.ToolName }}
                    </td>
                    
                  
                    <td
                      (click)="getCurrentDOMElementId(risk.DisplayId)"
                      [routerLink]="[
                      '/risk/'+ risk.PageName,
                      risk.RiskRequestId,
                      { App: risk.ApprovalLevel }
                    ]"
                    >
                      {{ risk.Source }}
                    </td>
                    <td
                      (click)="getCurrentDOMElementId(risk.DisplayId)"
                      [routerLink]="[
                      '/risk/'+ risk.PageName,
                      risk.RiskRequestId,
                      { App: risk.ApprovalLevel }
                    ]"
                    >
                      {{ risk.ApproveStatus }}
                    </td>
                    <td
                      (click)="getCurrentDOMElementId(risk.DisplayId)"
                      [routerLink]="[
                      '/risk/'+ risk.PageName,
                      risk.RiskRequestId,
                      { App: risk.ApprovalLevel }
                    ]"
                    >
                      {{ risk.LastApproveDate  | dateTimeFormat }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                style="width: 500px; margin-top: 15px; color: red"
               
              >
                {{ noRecordsMsg }}
              </div>
              
            </div>
             
            <!-- End table-responsive -->
            <!-- <div class="clearfix"></div> -->
          </div>
        </div>
      </div>
    </div>
    
  </div>
</div>
  